import {useLocation} from "react-router-dom"
import {getStatusPage} from "@indebted/api/paymentArrangement/getStatusPage"
import {useSuspenseQuery} from "@tanstack/react-query"

import {usePaymentArrangementId} from "../usePaymentArrangementId"

export const useStatusPageData = () => {
	const paymentArrangementID = usePaymentArrangementId()
	const location = useLocation()
	const status = location.pathname.split("/").pop()

	if (!status) {
		throw new Error("Status is required")
	}

	const result = useSuspenseQuery({
		queryKey: ["statusPage", paymentArrangementID, status],
		queryFn: () => getStatusPage(paymentArrangementID, status),
	})

	return result
}
